export const FormElementType = {
    TextField: 'TextField',
    Radio: 'Radio',
    Select: 'Select',
    File: 'File',
    MultiFile: 'MultiFile',
    ImageDropper: 'ImageDropper',
    CheckBox: 'CheckBox'
}

export default FormElementType
